import { useLocalStorage } from "@nens/react/hooks";

interface PublicUser {
  givenName: string;
  familyName: string;
  email: string;
}

// Save the public user (without id) in local storage, so that the user doesn't have to re-enter
// their name and email each time they open a public publication with the same browser.
export const PUBLIC_USER_KEY = "public-user";

export const savePublicUserInStorage = (givenName: string, familyName: string, email: string) => {
  const publicUser = { givenName, familyName, email };
  window.localStorage.setItem(PUBLIC_USER_KEY, JSON.stringify(publicUser));
};

export function usePublicUserFromStorage() {
  return useLocalStorage<PublicUser | null>(PUBLIC_USER_KEY, null);
}
